import AppState from './appState.store';

export const appState = new AppState();
if (typeof window !== 'undefined') {
    (window as any).appState = appState;
}
